import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _LoanAccountantConcept, _LoanCurrency } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { CurrencyEditor } from "../../../erp/cellEditor/Currency/CurrencyEditor";
import { MyEditor } from "../../../theme/Component/MyEditor";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectBudgetType } from "../../configuracion/select/SelectBudgetType";
import { SelectBudgetID } from "../../configuracion/BudgetID/SelectBudgetID";
import { BudgetResourceEditor } from "../../configuracion/BudgetResource/BudgetResource.Editor";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProjectID } from "../../configuracion/ProjectID/SelectProjectID";
import { LoanLineSelect } from "../LoanLine/LoanLineSelect";
import { ProjectSelect } from "../../../RemoteAbstractAction/editors/ProjectSelect";
import { ProjectSelectVdos } from "../../../RemoteAbstractAction/editors/ProjectSelectVdos";





export const LoanAccountantConcept = () => {

    const loanAccountantConcept = useDataBean(_LoanAccountantConcept);
    const single = Singleton.getInstance();
    const [loanline, setLoanline] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [loanline])

    const getLista = () => {

        loanAccountantConcept.instance.getLoanAccountantConceptCatalog(loanline).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        loanAccountantConcept.setBean({
            IDLoanLine: loanline
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        loanAccountantConcept.deleteItemVoid(loanAccountantConcept.bean.IDLoanCurrency).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        loanAccountantConcept.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDLoanAccountantConcept', visible: true },

        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Cuenta Contable Capital', property: 'AccountantIDStrCtName', visible: true },
        { title: 'Cuenta Contable Intereses', property: 'AccountantIDStrIntName', visible: true },
        { title: 'Cuenta Contable Provisión', property: 'AccountantIDStrProvName', visible: true },
        { title: 'Cuenta Contable Gasto', property: 'AccountantIDStrExpName', visible: true },
        { title: 'Cuennta Contable Ingreso', property: 'AccountantIDStrRevName', visible: true },
        { title: 'Utilizar Presupuesto', property: 'UseBudget', visible: true },
        { title: 'Tipo de Presupuesto Ingreso', property: 'BudgetTypeRevenueName', visible: true },
        { title: 'Tipo de Presupuesto Gasto', property: 'BudgetTypeExpName', visible: true },
        { title: 'Rubro Presupuestal Gasto', property: 'BudgetIDExpName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'IDBudgetSource', visible: true },
        { title: 'Área de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Proyecto', property: 'IDProject', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${loanAccountantConcept.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Conceptos Contable-Presupuestal">
            <div className="row">
                <div className="col-md-6">
                    <LoanLineSelect label="Selecciona Una Linea de Credito" idSelector={loanline} onChange={(e) => { setLoanline(e) }} />
                </div>
                <div className="col-md-12">
                    {loanline ? (
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={loanAccountantConcept.setBean}
                            listButtons={listaBotones()}
                            iconButtons={iconButtonsItem}
                        />
                    ) : (
                        <p>Seleccione una Línea de Crédito*.</p>
                    )}
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={loanAccountantConcept.bean.Name} onChange={loanAccountantConcept.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable Capital" jsonCode={loanAccountantConcept.bean.AccountantIDStrCt} onChange={(e) => loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "AccountantIDStrCt": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable Intereses" jsonCode={loanAccountantConcept.bean.AccountantIDStrInt} onChange={(e) => loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "AccountantIDStrInt": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable Provisión" jsonCode={loanAccountantConcept.bean.AccountantIDStrProv} onChange={(e) => loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "AccountantIDStrProv": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable Gasto" jsonCode={loanAccountantConcept.bean.AccountantIDStrExp} onChange={(e) => loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "AccountantIDStrExp": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuennta Contable Ingreso" jsonCode={loanAccountantConcept.bean.AccountantIDStrRev} onChange={(e) => loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "AccountantIDStrRev": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Utilizar Presupuesto" estado={loanAccountantConcept.bean.UseBudget} eventChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "UseBudget": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetType label="Tipo de Presupuesto Ingreso" idSelector={loanAccountantConcept.bean.IDBudgetTypeRevenue} onChange={(e: any) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDBudgetTypeRevenue": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "BudgetIDRev": e.JsonCode }) }} jsonCode={loanAccountantConcept.bean.BudgetIDRev} edit={false} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetType label="Tipo de Presupuesto Gasto" idSelector={loanAccountantConcept.bean.IDBudgetTypeExp} onChange={(e: any) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDBudgetTypeExp": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID label="Rubro Presupuestal Gasto" onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "BudgetIDExp": e.JsonCode }) }} jsonCode={loanAccountantConcept.bean.BudgetIDExp} edit={false} />
                            </div>
                            <div className="col-md-6">
                                <BudgetResourceEditor label="Recurso Presupuestal" idSelector={loanAccountantConcept.bean.IDBudgetResource} onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDBudgetResource": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BudgetResourceEditor label="Fuente de Financiamiento" idSelector={loanAccountantConcept.bean.IDBudgetSource} onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDBudgetSource": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label='Área de Negocio' returnType="Object" idSelector={loanAccountantConcept.bean.IDBusinessCore} onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDBusinessCore": e.Code }) }} />
                            </div>
                            <div className="col-md-6">
                                <ProjectSelectVdos label='Proyecto' idSelector={loanAccountantConcept.bean.IDProject} onChange={(e) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDProject": e }) }} />
                                {/* <SelectProjectID projectIDLn={loanAccountantConcept.bean.IDProject} edit={false} onChange={(e: any) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, "IDProject": e.IDLn }) }} /> */}
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <MyEditor val={loanAccountantConcept.bean.Description} onChange={(e: any) => { loanAccountantConcept.setBean({ ...loanAccountantConcept.bean, 'Description': e }) }} ></MyEditor>
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {loanAccountantConcept.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}